import { Button, Grid, Typography } from "@mui/material";
import CentralLabDetails from "./CentralLabDetails";
import { Add as AddIcon } from "@mui/icons-material";
import { useEffect, useState } from "react";
import { useCentralLab } from "../../hooks/useCentralLab";
import { useSnackbar } from "../../hooks/useSnackbar";
import { setOpenAddCentralLabModal } from "../../store/slices/studiesSlice";
import { AppState, useAppDispatch, useAppSelector } from "../../store";
import AddCentralLab from "./AddCentralLab";

const CentralLab = (props: any) => {
  const { selectedStudy } = props;
  const { handleError } = useSnackbar();
  const [isEdit, setIsEdit] = useState(false);
  const [centralLabData, setCentralLabData] = useState(null);
  const dispatch = useAppDispatch();
  const openAddCentralLabModal = useAppSelector(
    (state: AppState) => state.studiesSlice.openAddCentralLabModal
  );
  const {
    getCentralLabDetails,
    centralLabDetailsData,
    centralLabDetailsIsError,
    centralLabDetailsError,
  } = useCentralLab();
  const getCentralLabDetail = () => {
    getCentralLabDetails({ study_id: selectedStudy });
  };
  useEffect(() => {
    getCentralLabDetail();
  }, []);

  useEffect(() => {
    if (centralLabDetailsData) {
      setCentralLabData(centralLabDetailsData);
    }
  }, [centralLabDetailsData]);

  useEffect(() => {
    if (centralLabDetailsIsError) {
      setCentralLabData(null);
      const error: any = centralLabDetailsError;
      handleError(error, false);
    }
  }, [centralLabDetailsIsError, centralLabDetailsError]);

  return (
    <>
      <Grid container spacing={2} mb={2}>
        <Grid item xs>
          <Typography variant="h5">Central Lab</Typography>
        </Grid>
        {!centralLabData && (
          <Grid item justifyContent="flex-end">
            <Button
              variant="contained"
              endIcon={<AddIcon />}
              id="add_new_central_lab"
              onClick={() => dispatch(setOpenAddCentralLabModal(true))}
              aria-label="Click to add Central Lab details, which opens a new modal for data entry"
            >
              Add New
            </Button>
          </Grid>
        )}
      </Grid>
      {centralLabData && (
        <CentralLabDetails
          centralLabData={centralLabData}
          selectedStudy={selectedStudy}
          getCentralLabDetail={getCentralLabDetail}
          setCentralLabData={setCentralLabData}
          isEdit={isEdit}
          setIsEdit={setIsEdit}
        />
      )}
      {openAddCentralLabModal && (
        <AddCentralLab
          selectedStudy={selectedStudy}
          getCentralLabDetail={getCentralLabDetail}
          centralLabData={centralLabData}
          isEdit={isEdit}
        />
      )}
    </>
  );
};

export default CentralLab;
